import { useQuery } from 'react-query'
import { PaginatedRequest } from '../../../core/interfaces'
import { getPaymentMethods } from '../../orders'

export default function usePaymentMethods(query: PaginatedRequest<any>) {
  const {
    data: paymentMethods,
    error: paymentMethodsError,
    isLoading: paymentMethodsisLoading
  } = useQuery(['paymentMethods', query], () => getPaymentMethods(query), {
    refetchOnWindowFocus: false
  })
  return { paymentMethods, paymentMethodsError, paymentMethodsisLoading }
}
